import React, { Component } from 'react';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import message from 'antd/lib/message';
import api from '../api';

export default class TopUpTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amount: '',
      loading: false,
      resultBalance: null,
    };
  }

  topUp = async (value) => {
    if (value <= 0) {
      message.error('Amount must be greater than 0');
      return;
    }

    this.setState({ loading: true });
    const res = await api.topUp(value);
    if (res && res.ok && res.data && res.data.balance != null) {
      this.setState({ resultBalance: res.data.balance });
      message.success('Balance topped up');
    } else {
      this.setState({ resultBalance: null });
      message.error('Top up failed');
    }
    this.setState({ loading: false });
  };

  handleAmountChange = (e) => {
    this.setState({ amount: e.target.value });
  };

  handleTopUp = () => {
    const amount = Number(this.state.amount);
    this.topUp(amount);
    this.setState({ amount: '' });
  };

  render() {
    const { amount, loading, resultBalance } = this.state;

    return (
      <div className="tt-topup-container">
        <div className="tt-topup-presets">
          <Button
            onClick={() => this.topUp(1000)}
            loading={loading}
            disabled={loading}
          >
            +1000
          </Button>
          <Button
            onClick={() => this.topUp(5000)}
            loading={loading}
            disabled={loading}
          >
            +5000
          </Button>
          <Button
            onClick={() => this.topUp(10000)}
            loading={loading}
            disabled={loading}
          >
            +10000
          </Button>
        </div>

        <div className="tt-topup-custom">
          <Input
            type="number"
            placeholder="Custom amount"
            value={amount}
            onChange={this.handleAmountChange}
            onMouseDown={(e) => e.stopPropagation()}
          />
          <Button
            onClick={this.handleTopUp}
            loading={loading}
            disabled={loading}
            onMouseDown={(e) => e.stopPropagation()}
          >
            Top up
          </Button>
        </div>

        {resultBalance !== null && (
          <div className="tt-topup-result">
            New balance: {resultBalance}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/test-tools/tools/TopUpTool.js